import { Lock } from 'lucide-react';
import { mkIcon } from './utils';
export const SvgLockClosed = mkIcon(Lock);